// FETCH ALL FABRIC_INFORMATION
export const FETCH_FABRIC_INFORMATION_REQUEST = 'FETCH_FABRIC_INFORMATION_REQUEST';
export const FETCH_FABRIC_INFORMATION_SUCCESS = 'FETCH_FABRIC_INFORMATION_SUCCESS';
export const FETCH_FABRIC_INFORMATION_FAILURE = 'FETCH_FABRIC_INFORMATION_FAILURE';

export const UPDATE_REGENERATE_FABRIC_INFORMATION_REQUEST = 'UPDATE_REGENERATE_FABRIC_INFORMATION_REQUEST';
export const UPDATE_REGENERATE_FABRIC_INFORMATION_SUCCESS = 'UPDATE_REGENERATE_FABRIC_INFORMATION_SUCCESS';
export const UPDATE_REGENERATE_FABRIC_INFORMATION_FAILURE = 'UPDATE_REGENERATE_FABRIC_INFORMATION_FAILURE';

// FETCH ALL FABRIC_MASTER_WITHOUT_STYLE
export const FETCH_FABRIC_MASTER_WITHOUT_STYLE_REQUEST = 'FETCH_FABRIC_MASTER_WITHOUT_STYLE_REQUEST';
export const FETCH_FABRIC_MASTER_WITHOUT_STYLE_SUCCESS = 'FETCH_FABRIC_MASTER_WITHOUT_STYLE_SUCCESS';
export const FETCH_FABRIC_MASTER_WITHOUT_STYLE_FAILURE = 'FETCH_FABRIC_MASTER_WITHOUT_STYLE_FAILURE';

// CREATE FABRIC_INFORMATION
export const CREATE_FABRIC_INFORMATION_REQUEST = 'CREATE_FABRIC_INFORMATION_REQUEST';
export const CREATE_FABRIC_INFORMATION_SUCCESS = 'CREATE_FABRIC_INFORMATION_SUCCESS';
export const CREATE_FABRIC_INFORMATION_FAILURE = 'CREATE_FABRIC_INFORMATION_FAILURE';

// UPDATE FABRIC_INFORMATION
export const UPDATE_FABRIC_INFORMATION_REQUEST = 'UPDATE_FABRIC_INFORMATION_REQUEST';
export const UPDATE_FABRIC_INFORMATION_SUCCESS = 'UPDATE_FABRIC_INFORMATION_SUCCESS';
export const UPDATE_FABRIC_INFORMATION_FAILURE = 'UPDATE_FABRIC_INFORMATION_FAILURE';

// FETCH SINGLE FABRIC INFORMATION
export const FETCH_SINGLE_FABRIC_INFORMATION_REQUEST = 'FETCH_SINGLE_FABRIC_INFORMATION_REQUEST';
export const FETCH_SINGLE_FABRIC_INFORMATION_SUCCESS = 'FETCH_SINGLE_FABRIC_INFORMATION_SUCCESS';
export const FETCH_SINGLE_FABRIC_INFORMATION_FAILURE = 'FETCH_SINGLE_FABRIC_INFORMATION_FAILURE';

// DELETE FABRIC_INFORMATION
export const DELETE_FABRIC_INFORMATION_REQUEST = 'DELETE_FABRIC_INFORMATION_REQUEST';
export const DELETE_FABRIC_INFORMATION_SUCCESS = 'DELETE_FABRIC_INFORMATION_SUCCESS';
export const DELETE_FABRIC_INFORMATION_FAILURE = 'DELETE_FABRIC_INFORMATION_FAILURE';

// FETCH ALL PROPERTY_FOR_FABRIC_INFO
export const FETCH_PROPERTY_FOR_FABRIC_INFO_REQUEST = 'FETCH_PROPERTY_FOR_FABRIC_INFO_REQUEST';
export const FETCH_PROPERTY_FOR_FABRIC_INFO_SUCCESS = 'FETCH_PROPERTY_FOR_FABRIC_INFO_SUCCESS';
export const FETCH_PROPERTY_FOR_FABRIC_INFO_FAILURE = 'FETCH_PROPERTY_FOR_FABRIC_INFO_FAILURE';

// FETCH ALL FABRIC BY STYLE DETAIL ID
export const FETCH_FABRIC_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_FABRIC_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_FABRIC_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_FABRIC_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_FABRIC_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_FABRIC_BY_STYLE_DETAIL_ID_FAILURE';

export const RESET_FABRIC_INFORMATION_INFO = 'RESET_FABRIC_INFORMATION_INFO';

export const CREATE_FABRIC_INFORMATION_FORM = 'CREATE_FABRIC_INFORMATION_FORM';

export const UPDATE_FABRIC_INFORMATION_FORM = 'UPDATE_FABRIC_INFORMATION_FORM';

//FETCH INVOICE DATA
export const FETCH_FABRIC_INFO_INVOICE_REQUEST = 'FETCH_FABRIC_INFO_INVOICE_REQUEST';
export const FETCH_FABRIC_INFO_INVOICE_SUCCESS = 'FETCH_FABRIC_INFO_INVOICE_SUCCESS';
export const FETCH_FABRIC_INFO_INVOICE_FAILURE = 'FETCH_FABRIC_INFO_INVOICE_FAILURE';

export const RESET_FABRIC_INFO_INVOICE = 'RESET_FABRIC_INFO_INVOICE';

export const SEND_FAB_VERIFY_OTP_USERFORM_REQUEST = 'SEND_FAB_VERIFY_OTP_USERFORM_REQUEST';
export const SEND_FAB_VERIFY_OTP_USERFORM_SUCCESS = 'SEND_FAB_VERIFY_OTP_USERFORM_SUCCESS';
export const SEND_FAB_VERIFY_OTP_USERFORM_FAILURE = 'SEND_FAB_VERIFY_OTP_USERFORM_FAILURE';

export const FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_REQUEST = 'FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_REQUEST';
export const FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_SUCCESS = 'FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_SUCCESS';
export const FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_FAILURE = 'FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_FAILURE';